import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Router from 'sites/routes/router';
import PropTypes from 'prop-types';

import {
   listSelector,
   isFetchingNotificationsSelector,
   isFetchingNewNotificationsSelector,
   notificationsPanelSelector,
   isEmptyNotificationsSelector,
   isEmptyByFilterNotificationsSelector,
   isFetchingByFilterNotificationsSelector,
   unreadNotificationsCountSelector,
   unseenNotificationsCountSelector,
} from 'sites/state/modules/notifications/selectors';

import {
   screenWidthSelector,
   siteInfoSelector,
} from 'sites/state/modules/common/selectors';
import {
   updateNotifications,
   setNotificationsPanelAction,
   setUnreadCountAction,
   setUnseenCountAction,
} from 'sites/state/modules/notifications/actions';
import {
   fetchNewNotificationsOperation,
   fetchNotificationsByFilterOperation,
   markAllAsReadNotificationsOperations,
   markAllAsSeenNotificationsOperations,
} from 'sites/state/modules/notifications/operations';
import ReactDOM from 'react-dom';
import Notifications from 'sites/views/notifications';
import cx from 'classnames';
import { closePollModalAction, openClosePollConfirmDialogAction } from 'sites/state/modules/polls/actions';
import { openActivePollModalOperation } from 'sites/state/modules/polls/operations';

class NotificationsContainer extends Component {
   static propTypes = {
      screenWidth: PropTypes.number,
      list: PropTypes.object,
      fetchNewNotifications: PropTypes.func,
      fetchNotificationsByFilter: PropTypes.func,
      isFetchingNew: PropTypes.bool,
      updateNotifications: PropTypes.func,
      notificationsPanel: PropTypes.object,
      markAllAsRead: PropTypes.func,
      markAllAsSeen: PropTypes.func,
      isFetching: PropTypes.bool,
      isEmpty: PropTypes.bool,
      isEmptyByFilter: PropTypes.bool,
      isFetchingByFilter: PropTypes.bool,
      unreadNotificationsCount: PropTypes.number,
      unseenNotificationsCount: PropTypes.object,
      setUnreadCount: PropTypes.func,
      setUnseenCount: PropTypes.func,
      setNotificationsPanel: PropTypes.func,
      goTo: PropTypes.func,
      siteInfo: PropTypes.object,
      openPollModal: PropTypes.func,
      closePollModal: PropTypes.func,
      openClosePollConfirmDialog: PropTypes.func,
   }
   state = {
      promptFlag: null,
   };
   socket = null
   containerRef = React.createRef();
   filter = {};

   componentDidMount() {
      this.socket = window.siteNotificationSocket
      this._bindEvents();
   }
   componentWillUnmount(){
      const { setNotificationsPanel } = this.props;
      setNotificationsPanel({ withAnimation: false });
   }
   _bindEvents = () => {
      const { socket } = this;
      socket.removeAllListeners('message:add');
      socket.removeAllListeners('message:update');
      socket.on('message:add', (data) => {
         const { updateNotifications, unreadNotificationsCount, setUnreadCount, setUnseenCount, unseenNotificationsCount } = this.props;
         if(!!data) {
            if(!!this.checkNotificationMatchesFilter(data)) {
               updateNotifications(data)
               setUnreadCount(unreadNotificationsCount + 1)
            } else {
               setUnseenCount(unseenNotificationsCount?.count + 1)
            }
         }
      });
      socket.on('message:update', (data) => {
         const { updateNotifications } = this.props;
         if(!!data) {
            updateNotifications(data)
         }
      });
   }
   checkNotificationMatchesFilter = (data) => {
      let isSearchFilter = !!this.filter.hasOwnProperty('search') && !!this.filter.search;
      let isCategoryFilter = !!this.filter.hasOwnProperty('categories') && !!this.filter.categories;
      let isSortByFilter = !!this.filter.hasOwnProperty('sortBy') && !!this.filter.sortBy;
      let isMatchesSearch = true;
      let isMatchesCategory = true;
      let isMatchesSortBy = true;
      if(isSearchFilter) {
         let name = data.payload?.user?.username;
         let searchValue = this.filter.search;
         isMatchesSearch = !!name.toLowerCase().includes(searchValue.toLowerCase());
      }
      if(isCategoryFilter) {
         let category = 'comments';
         if(this.isChatMessage(data.category)) {
            category = 'chat_messages';
         }
         isMatchesCategory = !!this.filter.categories.includes(category);
      }
      if(isSortByFilter) {
         isMatchesSortBy = this.filter.sortBy === 'date_added:desc';
      }
      if(isSortByFilter) {
         isMatchesSortBy = this.filter.sortBy === 'date_added:desc';
      }
      return !!isMatchesSearch && !!isMatchesCategory && !!isMatchesSortBy
   }
   generateQuery = () => {
      const query = [];
      Object.keys(this.filter).forEach((key) => {
         if(key){
            if(this.filter[key]) {
               key !== 'count' && key !== 'sortBy' && key !== 'cursor' ? query.push(`query[]=${ key }=${ this.filter[key] }`) : query.push(`${ key }=${ this.filter[key] }`);
            }
         }
      });
      return query;
   };

   onFilterChange = (value, key) => {
      let data = value
      if(!!Array.isArray(value)) {
         data = value.join(',')
      }
      this.filter = {
         ...this.filter,
         [key]: data,
      }
      delete this.filter.cursor;
      let query = this.generateQuery();
      const { fetchNotificationsByFilter } = this.props;
      let el = document.querySelector('.notification-content-list');
      if(el) {
         el.scrollTop = 0;
      }
      fetchNotificationsByFilter(query)
   }

   notificationsScroll = (e) => {
      const { scrollHeight, clientHeight, scrollTop } = e.target
      if(((scrollHeight - scrollTop) - clientHeight < 1)) {
         this.nextPage()
      }
   }

   nextPage =  () => {
      const {
         fetchNewNotifications,
         isFetchingNew,
         list: { next_page_url: nextPageUrl },
      } = this.props;
      if(!!nextPageUrl && !isFetchingNew) {
         let cursor = nextPageUrl.split('?')[1]?.slice(7);
         this.filter = {
            ...this.filter,
            cursor: cursor,
         };
         let query = this.generateQuery();
         fetchNewNotifications(query);
      } else {
         return
      }
   }

   generateContentLink = (notification) => {
      const payload = notification?.payload || {};
      const id = payload?.resource_id;
      const type = payload?.type;
      let route = null;
      if(!id){
         return route;
      }
      switch (type) {
         case 'video':
            route = Router.route('VIDEOS_INDIVIDUAL').getCompiledPath({ id });
            break;
         case 'story':
            if(['comment_like', 'comment_reply'].includes(notification?.key)){
               route = Router.route('STORIES_COMMENTS').getCompiledPath({ id });
            }
            break;
         case 'photoset':
            route = Router.route('PHOTOSETS_INDIVIDUAL').getCompiledPath({ id });
            break;
         case 'record_stream':
            route = Router.route('LIVE_STREAM_RECORD').getCompiledPath({ id });
            break;

         default:
            break;
      }
      return route;
   }

   closeNotificationModal = () => {
      const { setNotificationsPanel } = this.props;
      this.filter = {};
      setNotificationsPanel({ isOpen: false, withAnimation: true });
   }

   getPanelStyle = () => {
      const { notificationsPanel } = this.props;
      let state = {
         WebkitTransform: notificationsPanel?.isOpen ? 'translateX(0)' : 'translateX(100%)',
         transform: notificationsPanel?.isOpen ? 'translateX(0)' : 'translateX(100%)',
      };
      if(notificationsPanel?.withAnimation){
         state = {
            animation: notificationsPanel?.isOpen ? 'slide-in-right-chat 0.6s forwards' : 'slide-out-right-chat 0.6s forwards',
         }
      }
      return state
   }

   onClickNotificationItemLinkButton = (notificationItem) => {
      switch (notificationItem.key) {
         case "poll_published":
         case "poll_ended":
         case "poll_24_hours_left":
            const { payload } =    notificationItem
            const { openPollModal, openClosePollConfirmDialog, closePollModal } = this.props

            openPollModal((pollData) => {
               if(pollData?.id !== payload?.resource_id) {
                  closePollModal()

                  setTimeout(() => {
                     openClosePollConfirmDialog('unpublished_poll')
                  })
               }
            })

            break;

         default:
            break;
      }
   }

   render() {
      const {
         screenWidth,
         list,
         isEmpty,
         isEmptyByFilter,
         isFetching,
         isFetchingNew,
         isFetchingByFilter,
         markAllAsSeen,
         markAllAsRead,
         unreadNotificationsCount,
         goTo,
         notificationsPanel,
         siteInfo,
      } = this.props;
      return (
         <>
            {
               ReactDOM.createPortal(
                  <div
                     style={ {
                        ...this.getPanelStyle(),
                        zIndex: '31',
                        height: '100vh',
                        top: '0',
                     } }
                     id='member_notifications_modal'
                     className={ cx({
                        'fixed z-10 bottom-0 member-right-chat': true,
                        'shadow dark:shadow-dark': notificationsPanel?.isOpen,
                     }) }

                  >
                     <Notifications
                        generateContentLink={ this.generateContentLink }
                        notifications={ list?.data || [] }
                        isEmpty={ isEmpty }
                        isFetching={ isFetching }
                        isFetchingByFilter={ isFetchingByFilter }
                        isEmptyByFilter={ isEmptyByFilter }
                        isFetchingNew={ isFetchingNew }
                        filters={ this.filter }
                        isMobile={ screenWidth < 1024 }
                        onFilterChange={ this.onFilterChange }
                        onScroll={ this.notificationsScroll }
                        markAllAsRead={ () => {
                           markAllAsSeen();
                           markAllAsRead(null, false);
                        } }
                        onClickCard={ item => {
                           markAllAsRead(item.id, Boolean(item.is_read))
                        } }
                        onCloseModal={ this.closeNotificationModal }
                        isDisabledMarkAllAsReadButton={ !unreadNotificationsCount }
                        goToNotificationPreferences={ _ => goTo(Router.route('MY_ACCOUNT_NOTIFICATION_PREFERENCES').getCompiledPath()) }
                        screenWidth={ screenWidth }
                        goToOrderDetails={ (id) => {
                           goTo(Router.route('ORDER_DETAILS').getCompiledPath({ id }))
                        } }
                        siteInfo={ siteInfo }
                        goToLink={ this.onClickNotificationItemLinkButton }
                     />
                  </div>,
                  document.querySelector('body')
               )
            }
         </>
      )
   }
}
const mapStateToProps = (state) => {
   return {
      notificationsPanel: notificationsPanelSelector(state),
      screenWidth: screenWidthSelector(state),
      list: listSelector(state),
      isFetching: isFetchingNotificationsSelector(state),
      isFetchingNew: isFetchingNewNotificationsSelector(state),
      isEmpty: isEmptyNotificationsSelector(state),
      isEmptyByFilter: isEmptyByFilterNotificationsSelector(state),
      isFetchingByFilter: isFetchingByFilterNotificationsSelector(state),
      unreadNotificationsCount: unreadNotificationsCountSelector(state),
      unseenNotificationsCount: unseenNotificationsCountSelector(state),
      siteInfo: siteInfoSelector(state),
   }
}

const mapDispatchToProps = (dispatch) => {
   return {
      fetchNewNotifications: (query) => dispatch(fetchNewNotificationsOperation(query)),
      fetchNotificationsByFilter: (query) => dispatch(fetchNotificationsByFilterOperation(query)),
      updateNotifications: (data) => dispatch(updateNotifications(data)),
      markAllAsRead: (id, isRead = false) => dispatch(markAllAsReadNotificationsOperations(id, isRead)),
      markAllAsSeen: () => dispatch(markAllAsSeenNotificationsOperations()),
      setNotificationsPanel: data => dispatch(setNotificationsPanelAction(data)),
      setUnreadCount: unreadCount => dispatch(setUnreadCountAction(unreadCount)),
      setUnseenCount: unseenCount => dispatch(setUnseenCountAction(unseenCount)),
      goTo: (location) => {
         dispatch(push(location))
      },
      openPollModal: (callback) => dispatch(openActivePollModalOperation(callback)),
      closePollModal: () => dispatch(closePollModalAction()),
      openClosePollConfirmDialog: (type) => dispatch(openClosePollConfirmDialogAction(type)),
   }
}
export default connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer);
